import { Navigation } from '../../models/navigation.model';

export const mainNavigation: Navigation[] = [
  {
    name: 'ibSpecific.menu.home',
    route: '/home',
    icon: 'home',
    iconActive: 'home_active',
    permission: 'VIEW_ACCOUNTS'
  },
  {
    name: 'menu_accounts',
    route: '/accounts',
    icon: 'accounts',
    iconActive: 'accounts_active',
    permission: 'VIEW_ACCOUNTS'
  },
  {
    name: 'more_options_savings',
    route: '/savings',
    icon: 'accounts',
    iconActive: 'accounts_active',
    permission: 'VIEW_ACCOUNTS'
  },
  {
    name: 'more_options_deposits',
    route: '/deposits',
    icon: 'accounts',
    iconActive: 'accounts_active',
    permission: 'VIEW_ACCOUNTS'
  },
  {
    name: 'more_options_credit',
    route: '/loans',
    icon: 'accounts',
    iconActive: 'accounts_active',
    permission: 'VIEW_ACCOUNTS'
  },
  {
    name: 'menu_cards',
    route: '/cards',
    icon: 'cards',
    iconActive: 'cards_active',
    permission: 'VIEW_CARDS'
  },
  {
    name: 'menu_payment',
    route: '/payments',
    icon: 'payments',
    iconActive: 'payments_active',
    permission: 'VIEW_PAYMENTS'
  },
  // {
  //   name: 'ic_option_menu_47',
  //   route: '/e-bills',
  //   icon: 'payments',
  //   iconActive: 'payments_active'
  // },
  // {
  //   name: 'ibSpecific.sepa.title_nav',
  //   route: '/sepa',
  //   icon: 'payments',
  //   iconActive: 'payments_active'
  // },

  {
    name: 'more_options_locations',
    route: '/locations',
    icon: 'locations',
    iconActive: 'locations_active',
    permission: 'VIEW_ACCOUNTS'
  }
];
